import {MarkerType} from '@xyflow/react';

export const defaultEdge = {
  markerEnd: {
    type: MarkerType.ArrowClosed,
    width: 20,
    height: 20,
    color: '#FF0072',
  },
  style: {
    strokeWidth: 2,
    stroke: '#FF0072',
  },
  type: 'customStep',
};
